import type { TypePolicies } from '../../../../utils/types/TypePolicies';

export const typePolicies: TypePolicies = {
  AssetAggregateAppearance: {
    merge: true,
    keyFields: false,
  },
  AssetAggregateAppearanceHeader: {
    merge: true,
    keyFields: false,
  },
};
